module.exports = __webpack_public_path__ + "img/football_gif.c3255505.gif";